import * as React from 'react';
import ReactDOM from 'react-dom';
import {compose} from 'redux';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment, {Moment} from 'moment';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'react-datepicker/dist/react-datepicker.css';
import * as _ from "lodash";
import {DateFormatter} from '../../../../utils/DateFormatter';
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";
import {virtualizedTableId} from "../../VirtualizedTableUtils";
import {selectLanguage} from '../../../../redux/selectors';
import {IReduxState} from '../../../../redux/IReduxState';

interface IMapStateToProps {
    language: string;
}

interface DateInputProps extends IVirtualizedTableCellComponentProps, IMapStateToProps { }

interface DateInputState { }

class DateInput extends React.Component<DateInputProps, DateInputState> {
    pickerRef: any;

    componentDidMount() {
        // @ts-ignore Currently, this component is used only in virtualized table
        // which is rendered by the time this function is called
        const element = document.getElementById(virtualizedTableId);
        if(element) {
            element.addEventListener(
                'scroll',
                this.onClose,
                true
            );
        }
    }

    componentWillUnmount(): void {
        // @ts-ignore Currently, this component is used only in virtualized table
        // which is rendered by the time this function is called

        const element = document.getElementById(virtualizedTableId);
        if(element) {
            element.removeEventListener(
                'scroll',
                this.onClose,
                true
            );
        }
    }

    onClose = () => {
        if (this.pickerRef && this.pickerRef.state.open) {
            this.pickerRef.setOpen(false);
        }
    }

    onChange = (date: Moment) => {
        if (date !== null) {
            // the ui date format has to be adapted to BE format, before the value is sent to BE for update
            this.props.onChange(date.format("YYYY-MM-DD"));
        } else {
            this.props.onChange(undefined);
        }
    }

    public render() {
        const {value: receivedValue} = this.props;
        let value = _.isDate(receivedValue) || (receivedValue !== undefined && receivedValue.length) > 0 ? moment(receivedValue) : receivedValue;
        return (
            <DatePicker
                ref={(ref: any) => this.pickerRef = ref}
                selected={value}
                onChange={this.onChange}
                readOnly={this.props.readOnly}
                disabled={this.props.readOnly}
                placeholderText={this.props.t("NO_DATE_SELECTED")}
                dateFormat={DateFormatter.displayDateFormat}
                showWeekNumbers={true}
                locale={this.props.language === 'de' ? 'de' : 'en-gb'}
                // @ts-ignore Currently, this component is used only in virtualized table
                // which is rendered by the time this function is called
                popperContainer={({children}) => ReactDOM.createPortal(children, document.getElementById('grid-container'))}
                popperModifiers={{
                    preventOverflow: {
                        enabled: true
                    }
                }}
            />
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    language: selectLanguage(state)
});

export default compose<React.ComponentType<DateInputProps>>(
    connect<IMapStateToProps>(mapStateToProps)
)(DateInput);



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/DateInput.tsx